import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircleIcon, FrownIcon, HeartCrackIcon, HomeIcon, TrendingDownIcon } from 'lucide-react';
export function ProblemSection() {
  const painPoints = [{
    icon: <FrownIcon className="w-8 h-8 text-[#8B1A1A]" data-id="element-134" />,
    text: 'Te duele ver que tu hijo ya no juega con ilusión, sino con miedo y presión'
  }, {
    icon: <TrendingDownIcon className="w-8 h-8 text-[#8B1A1A]" data-id="element-135" />,
    text: 'Sabes que puede llegar lejos pero un error lo hunde y le destruye la confianza'
  }, {
    icon: <AlertCircleIcon className="w-8 h-8 text-[#8B1A1A]" data-id="element-136" />,
    text: 'No sabes cómo acompañarlo sin presionarlo más o empeorar lo que siente'
  }, {
    icon: <HomeIcon className="w-8 h-8 text-[#8B1A1A]" data-id="element-137" />,
    text: 'La presión del fútbol ya se siente también en casa antes y después de cada partido'
  }, {
    icon: <HeartCrackIcon className="w-8 h-8 text-[#8B1A1A]" data-id="element-138" />,
    text: 'Quieres que vuelva a disfrutar, que mejore su rendimiento y se fortalezca mentalmente dentro y fuera del campo'
  }];
  return <section className="py-16 md:py-20 bg-brand-cream-dark/50" data-id="element-139">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-140">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 md:mb-12" data-id="element-141">
          <h2 className="text-3xl md:text-4xl font-heading text-brand-slate mb-4" data-id="element-142">
            Este producto es para ti si...
          </h2>
          <div className="w-24 h-1 bg-brand-amber mx-auto rounded-full" data-id="element-143"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-144">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start p-6 bg-white rounded-xl shadow-sm border border-brand-slate/5 hover:shadow-md transition-shadow duration-300" data-id="element-145">
              <div className="flex-shrink-0 mr-4 mt-1 p-3 rounded-full bg-[#A3170D19]" data-id="element-146">
                {point.icon}
              </div>
              <p className="text-lg text-brand-slate-light leading-relaxed font-medium" data-id="element-147">
                {point.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}